import React, {useEffect, useState} from 'react'
import TierCard from './TierCard'
import {Alert, Col} from 'reactstrap' 
import {connect} from 'react-redux'
import {clearPlanAlert, getPlanByApiAndOrganization} from '../../../redux/actions/plans';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

const TierCardContainer = (props) => {
    // Destructure all needed props
    const { plan, show, tiers, visibleTierGroup } = props;
    
    // Always set arrow to 'up' to show details
    const arrow = 'up';

    const mapDescriptionToBullets = (tier) => {
        let description = tier.description || '';
        // Split by pipe separator
        let bullets = description.split('|');
        // Filter based on dashboard view
        if (visibleTierGroup === 'MARKETER') {
            // If MARKETER, only show marketing bullets (starting with '-')
            bullets = bullets.filter(bullet => bullet.trim().startsWith('-'));
        } else {
            // If NOT MARKETER, filter out marketing bullets (starting with '-')
            bullets = bullets.filter(bullet => !bullet.trim().startsWith('-'));
        }

        // Map to list items, removing '-' prefix if present
        return bullets.map((bullet) => {
            const trimmedBullet = bullet.trim();
            const cleanedBullet = trimmedBullet.startsWith('-') ? trimmedBullet.substring(1) : trimmedBullet;
            return <li className="pricing-card__feature" key={bullet}>{cleanedBullet}</li>;
        });
    }
            
    const renderAlertForDiscontinuedPlan = (tiers, plan) => {
        const oldButNoDiscontinueAlertNeeded = ['9942e4b0-054e-11ee-b180-850362109ba1', '9942e4b1-054e-11ee-b180-8523462109ba', '9942bda0-054e-11ee-b180-342362119ba3', '9942bda0-054e-11ee-b180-342362178ba2', '9942bda0-054e-11ee-b180-342362109ba4', '9942bda0-054e-11ee-b180-342362109ba1']
        let currentTier = tiers.find((t) => t.id === plan.tierId) || {};

        const isOldButNoDiscontinueAlertNeeded = oldButNoDiscontinueAlertNeeded.includes(currentTier.id);

        if(currentTier.isDiscontinued && !isOldButNoDiscontinueAlertNeeded){
            return (
                <Alert color={'success'} className="alert--bordered" isOpen={true}>
                    <div className={'padding5'}>
                        <span><strong>NOTE:</strong>{' The plan that you\'re currently on has been discontinued. However there is no need to worry as you can keep it for as long as you would like.'}</span>
                        <p><strong>{'Current Plan: '}</strong>{currentTier.name}</p>
                        <p><strong>{`Current Price: $${currentTier.priceMonthly}/mo`}</strong></p>
                        <p><strong>{'You get:'}</strong></p>
                        <ul>
                            {mapDescriptionToBullets(currentTier)}
                        </ul>
                    </div>
                </Alert>
            )
        }
    }

    const renderTiers = () => {
        const noTrials = useFeatureIsOn('no_trial');
        
        return tiers &&  tiers.map((tier, index) => {
            
            let shouldShowTier = !tier.isTrial && !tier.isDiscontinued;
            // if the tier is for an expirment check that feature to see if we should show it
            if(tier.isExperimental && tier.positiveFeatureIds){
                const anyFeaturesOn = tier.positiveFeatureIds.split(',').some((feat) => useFeatureIsOn(feat));
                shouldShowTier = anyFeaturesOn;
            }
            if (tier.negativeFeatureIds) {
                const valueOfFeat = tier.negativeFeatureIds.split(',').some((feat) => useFeatureIsOn(feat));
                shouldShowTier = !valueOfFeat;
            }
            if (tier.isDiscontinued) {
                shouldShowTier = false;
            }


            return shouldShowTier ? <TierCard key={`${tier.id}-${index}`} arrow={arrow} tier={tier} currentTierId={plan.tierId} plan={plan} visibleTierGroup={visibleTierGroup}/> : null;
        })
    }

    return (
        <>
            {tiers && renderAlertForDiscontinuedPlan(tiers, plan)}
            <div className={'billing--tier--container'}>
                {renderTiers()}
            </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    stripeModalVisible: state.stripeModal.visible,
    freeModalVisible: state.stripeModal.freeModalVisible,
    stripeModalTier: state.stripeModal.tier,
})

const mapDispatchToProps = (dispatch) => ({
    clearPlanAlert: () => dispatch(clearPlanAlert()),
    getPlanByApiAndOrganization: (() => dispatch(getPlanByApiAndOrganization())),
});

export default connect(mapStateToProps, mapDispatchToProps)(TierCardContainer)
